/**
 * @interface This is basically a hack to ensure implementors inherit from Foundation.Promise.
 */
Foundation.View.Interface = function () {};

/**
 * @param {string} field
 */
Foundation.View.Interface.prototype.get = function (field) {};

/**
 * @param {string} field
 * @param {*} value
 * @return {Foundation.Observable}
 */
Foundation.View.Interface.prototype.set = function (field, value) {};

/**
 * @param {function()} callback
 * @return {Foundation.Promise}
 */
Foundation.View.Interface.prototype.then = function (callback) {};

/**
 * @param {function()} callback
 * @return {Foundation.Promise}
 */
Foundation.View.Interface.prototype.otherwise = function (callback) {};

/**
 * @param {function ()} callback
 * @return {Foundation.Promise}
 */
Foundation.View.Interface.prototype.always = function (callback) {};

/**
 * @param {Foundation.Promise} spouse
 * @return {Foundation.Promise}
 */
Foundation.View.Interface.prototype.marry = function (spouse) {};

/* eslint no-unused-vars: "off" */
